import "./conferences.css";

import React from "react";

import { CONFERENCES, VENUE_LINK } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { LinkButton, PageLayout } from "../general/PageSections";
import Slideshow from "../general/Slideshow";

const Conferences = () => {
  return (
    <PageLayout title={CONFERENCES.TITLE}>
      <PageMeta
        title={CONFERENCES.TITLE}
        description={CONFERENCES.DESCRIPTION}
      />
      <section className={"content-box"}>
        <h2 className={"content-box-heading"}>{CONFERENCES.HEADING}</h2>
        <hr className={"rule"} />
        <div className={"text-columns"}>
          {CONFERENCES.COLUMNS.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
        <p className={"conferences-venue"}>
          {CONFERENCES.VENUE_TEXT}
          <a
            href={VENUE_LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CONFERENCES.VENUE_LINK_LABEL}
          </a>
          .
        </p>
      </section>

      <Slideshow
        photos={CONFERENCES.SLIDES}
        label={"Photos of the conference facility"}
        className={"page-slideshow is-short"}
        autoplayMs={5000}
      />

      <section
        className={"content-box conferences-packages"}
        aria-labelledby={"packages-title"}
      >
        <h2
          id={"packages-title"}
          className={"content-box-heading"}
        >
          {CONFERENCES.PACKAGES_TITLE}
        </h2>
        <div className={"conferences-packages-grid"}>
          <div>
            {CONFERENCES.PACKAGES.map((pkg) => (
              <div
                key={pkg.title}
                className={"conferences-package"}
              >
                <hr className={"rule"} />
                <h3 className={"conferences-package-title"}>{pkg.title}</h3>
                <ul>
                  {pkg.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
            <LinkButton href={CONFERENCES.PRICING_FILE}>{CONFERENCES.PRICING_LABEL}</LinkButton>
          </div>
          <div className={"conferences-packages-media"}>
            <img
              src={CONFERENCES.PACKAGES_IMAGE.src}
              alt={CONFERENCES.PACKAGES_IMAGE.alt}
              loading={"lazy"}
            />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Conferences;
